import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const { pathname, hash } = useLocation();
  const { language, setLanguage, t } = useLanguage();

  const current = (path) => (pathname === path && !hash ? 'page' : undefined);

  return (
    <header className="site-header">
      <div className="wrap site-header__inner">
        <Link to="/" className="brand" aria-label="Olivier Gautheron">
          O.G
        </Link>
        <nav className="site-nav" aria-label="Main">
          <ul className="nav-list">
            <li>
              <Link to="/" className="nav-link" aria-current={current('/')}>
                {t('home')}
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className="nav-link"
                aria-current={current('/projects')}
              >
                {t('projects')}
              </Link>
            </li>
            <li>
              <Link
                to={{ pathname: '/', hash: '#contact' }}
                className="nav-link"
                aria-current={pathname === '/' && hash === '#contact' ? 'page' : undefined}
              >
                {t('contact')}
              </Link>
            </li>
          </ul>
          <div className="tools">
            <div className="segmented" role="group" aria-label="Language">
              {['en', 'fr'].map((code) => (
                <button
                  key={code}
                  type="button"
                  aria-pressed={language === code}
                  onClick={() => setLanguage(code)}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
            <ThemeToggle />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
